import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import {
  ListItemButton as MuiListItemButton,
  Typography as MuiTypography,
  ListItemIcon as MuiListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';

const ListItemIcon = styled(MuiListItemIcon)(({ theme }) => ({
  color: theme.palette.common.white,
}));

const ListItemButton = styled(MuiListItemButton, {
  shouldForwardProp: (prop) => prop !== 'wide',
})(({ theme }) => ({
  borderRadius: '6px',
  padding: '8px 10px',
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.dark,
    fontSize: '18px',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    fontSize: '18px',
    borderRadius: '6px',
  },
}));

const Typography = styled(MuiTypography, {
  shouldForwardProp: (prop) => prop !== 'wide' && prop !== 'selected',
})(({ wide }) => ({
  fontSize: '14px',
  fontWeight: '400',
  ...(!wide && {
    paddingLeft: '9px',
    display: 'none',
  }),
}));

export const MenuItem = ({ item, sx, selected, wide }) => (
  <Tooltip
    title={!wide ? item.title : ''}
    placement="right"
    arrow
  >
    <ListItemButton
      component={Link}
      to={item.path}
      sx={sx}
      selected={selected}
      data-testid="menu-item"
    >
      <ListItemIcon>{item.icon}</ListItemIcon>
      <ListItemText
        primary={
          <Typography
            variant="subtitle2"
            wide={wide}
            data-testid="menu-item-title"
          >
            {item.title}
          </Typography>
        }
      />
    </ListItemButton>
  </Tooltip>
);
